import { useEffect } from 'react';
import { RECAPTCHASITEKEY } from 'configs/app-global';
import ReCAPTCHA from 'react-google-recaptcha';

const Recaptcha = ({ onChange }) => {
  const hasSiteKey = Boolean(RECAPTCHASITEKEY && RECAPTCHASITEKEY.trim());

  useEffect(() => {
    // When no sitekey (e.g. dev), allow form submit without recaptcha
    if (!hasSiteKey) {
      onChange('no-recaptcha');
    }
  }, [hasSiteKey, onChange]);

  const handleRecaptchaChange = (value) => {
    onChange(value);
  };

  if (!hasSiteKey) {
    return null;
  }

  return (
    <ReCAPTCHA
      sitekey={RECAPTCHASITEKEY}
      onChange={handleRecaptchaChange}
    />
  );
};

export default Recaptcha;